import footerStyle from './footer.module.css'

export default function Footer() {
    return <div className={footerStyle.footer}>
        <span> ©Social Finance Israel הגר - תכנית קרסו למחקר ופיתוח דיור חברתי, הפקולטה למשפטים, אוניברסיטת תל אביב • </span>
        <a href={`mailto:info@urbanimpacttool.com`} className={footerStyle.mail} target="_blank">צור קשר</a>
    </div>
}